import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Tab content area.
/* Cannot desctructure the for keyword here, unfortunately. */
export default function TabPanel(props) {
  const { activeName, className, children, a11yKeyboard } = props;
  const a11yAttrs = a11yKeyboard
    ? {
        role: 'tabpanel',
        id: `tabpanel-${props.for}`,
        'aria-labelledby': `tab-${props.for}`,
      }
    : {};
  return (
    <div
      style={{ display: props.for === activeName ? 'block' : 'none' }}
      className={classnames('tab-panel', className)}
      {...a11yAttrs}
    >
      {children}
    </div>
  );
}

TabPanel.propTypes = {
  activeName: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  for: PropTypes.string.isRequired,
  a11yKeyboard: PropTypes.bool,
};

TabPanel.defaultProps = {
  className: '',
  activeName: null,
  a11yKeyboard: false,
};
